import { useContext } from 'react';
import styled, { css } from 'styled-components';
import { ar } from 'src/styles/common';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import { media } from 'src/styles/designs';
import { EventPageContext } from 'src/modules/events/components/EventPage/EventPageContext';
import { NeauviaPlayerLayer } from 'src/components/player';

const Container = styled(ConstraintContainer)<{ $first: boolean }>`
  position: relative;
  ${ar(16 / 9, 'max(20vw, calc(100vh - var(--header-static-height) - 130px))')}
  ${media.w.lessThan.desktop} {
    .player__locked-content {
      --base-unit: 100vw / 500;
    }
  }
  ${({ $first }) =>
    $first &&
    css`
      order: -1;
    `}
`;

export const EventPageVideoPlayer = () => {
  const { event, isUpcoming, isNow, isCompleted } =
    useContext(EventPageContext);
  const video = event.videos[0]?.videos_id;

  if (!video || isUpcoming) {
    return null;
  }

  return (
    <Container $first={isNow || isCompleted}>
      <NeauviaPlayerLayer video={video} autoPlay={true} />
    </Container>
  );
};
